import { useParams } from 'react-router';
import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { Button, Screen } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { BackButton, CenteredSpinner, ConfirmPopup } from '~/commonComponents';
import Form, { FORM_FIELDS } from '../multiday/components/Form';
import { useEditJobForm } from './hooks/useEditJobForm/useEditJobForm';
import { useJob } from './hooks/useJob/useJob';

export const EditOpenJob = () => {
  const { jobId } = useParams();
  const { job, isLoading: isLoadingJob } = useJob(jobId);
  const {
    formValues,
    handleSubmit,
    setFormValues,
    isLoading: isSaving,
    confirmationExitModalOpen,
    setConfirmationExitModalOpen,
    clearPendingNavigation,
    navigateToPending,
  } = useEditJobForm(job);

  if (isLoadingJob || !formValues) {
    return (
      <Screen variant="standard">
        <Screen.Header
          start={<BackButton />}
          title={job?.isOnsiteInterview ? 'Edit Interview' : 'Edit Shift'}
        />
        <Screen.Body>
          <CenteredSpinner minHeight={400} />
        </Screen.Body>
      </Screen>
    );
  }

  return (
    <>
      <Screen variant="standard">
        <Screen.Header
          start={<BackButton />}
          title={job?.isOnsiteInterview ? 'Edit Interview' : 'Edit Shift'}
        />
        <Screen.Body>
          <Form
            job={job}
            formValues={formValues}
            setFormValues={setFormValues}
            disabledFields={[FORM_FIELDS.PROFESSIONAL, FORM_FIELDS.SKILLS] as never}
            editDate
            source="open_shift"
          />
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Button
              onClick={handleSubmit}
              isLoading={isSaving}
              data-cy="save-changes-button"
              size="lg"
            >
              Save Changes
            </Button>
          </div>
        </Screen.Body>
      </Screen>

      {confirmationExitModalOpen && (
        <ConfirmPopup
          Icon={() => <OutlineWarning01Icon size={80} color={colors.primary[500]} />}
          leftButtonAction={() => {
            clearPendingNavigation();
            setConfirmationExitModalOpen(false);
          }}
          leftButtonText="Go Back"
          rightButtonAction={navigateToPending}
          rightButtonText="Leave Anyway"
          title="Are You Sure You Want to Leave?"
          titleStyle={{ marginBottom: 20, marginTop: 20 }}
          descriptionStyle={{ marginBottom: 40 }}
          description="You've made changes to your shift request that haven't been saved. Do you still want to leave?"
        />
      )}
    </>
  );
};
